module.exports = __webpack_public_path__ + "static/virtual_reality-446a64143cad88476fd4b58680471772.svg";